import { PermissionsTypes } from 'enum/permissionsType'
import { ModeratorPermissions } from 'models/moderatorPermissions.model'

const PERMISSIONS_CONDITIONED = {
  [PermissionsTypes.course]: {
    [ModeratorPermissions.editCourse]: true,
    [ModeratorPermissions.manageCourses]: false,
  },
  [PermissionsTypes.profile]: {
    [ModeratorPermissions.editCourse]: false,
    [ModeratorPermissions.manageCourses]: true,
  },
}
export const usePermissionsConditioned = (variant: PermissionsTypes) =>
  PERMISSIONS_CONDITIONED[variant]
